import { render, staticRenderFns } from "./Product_lh.vue?vue&type=template&id=0f906a38&scoped=true&"
import script from "./Product_lh.vue?vue&type=script&lang=js&"
export * from "./Product_lh.vue?vue&type=script&lang=js&"
import style0 from "./Product_lh.vue?vue&type=style&index=0&id=0f906a38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f906a38",
  null
  
)

export default component.exports